<template>
  <div class="side-panel__body">
    <div class="d-flex flex-column align-end keypad">
      <div class="d-flex justify-end">
        <v-btn @click="onClickExpand" class="mr-1" small dark><v-icon small>mdi-arrow-expand</v-icon></v-btn>
        <v-btn @click="onClickCollapse" small dark><v-icon small>mdi-arrow-collapse</v-icon></v-btn>
      </div>
      <div class="mt-1" style="width: 100%">
        <v-expansion-panels v-model="openPanelFlags" accordion multiple dark>
          <v-expansion-panel>
            <v-expansion-panel-header>Camera 🎥</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div
                  class="mb-3 d-flex align-center"
                  v-for="({ actionId, label, onClick, shortcutKey }, i) in cameraButtons"
                  :id="actionId"
                  :key="i"
                >
                  <play-button @click="onClick"></play-button>
                  <span class="ml-2 my-span">{{ label }}</span>
                  <v-chip class="ml-2" x-small>{{ shortcutKey }}</v-chip>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Actions 🏃‍♀️</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div>
                <div
                  class="d-flex align-center"
                  v-for="({ actionId, label, onClick, shortcutKey }, i) in actionButtons"
                  :id="actionId"
                  :key="i"
                >
                  <play-button @click="onClick"></play-button>
                  <span class="ml-2 my-span">{{ label }}</span>
                  <div class="ml-2"></div>
                  <v-chip class="ml-2" x-small>{{ shortcutKey }}</v-chip>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Emotions 😃</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-2">
                <div
                  class="d-flex align-center"
                  v-for="({ actionId, label, onClick, shortcutKey }, i) in emotionButtons"
                  :id="actionId"
                  :key="i"
                >
                  <play-button @click="onClick"></play-button>
                  <span class="ml-2 my-span">{{ label }}</span>
                  <div class="ml-2"></div>
                  <v-chip class="ml-2" x-small>{{ shortcutKey }}</v-chip>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Extras</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-2">
                <div
                  class="d-flex align-center"
                  v-for="({ actionId, label, onClick, shortcutKey }, i) in idleButtons"
                  :id="actionId"
                  :key="i"
                >
                  <play-button @click="onClick"></play-button>
                  <span class="ml-2 my-span">{{ label }}</span>
                  <div class="ml-2"></div>
                  <v-chip v-if="shortcutKey" class="ml-2" x-small>{{ shortcutKey }}</v-chip>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
  </div>
</template>

<script>
import AniconBounceLoader from "../../../components-web/AniconBounceLoader.vue";
import UiButton from "../../../components-web/UiButton.vue";
import ActionLabel from "./ActionLabel.vue";

// {label, onClick, shortcutKey}
export default {
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AniconBounceLoader,
    UiButton,
    ActionLabel,
  },
  mounted() {},
  data() {
    return {
      openPanelFlags: [0, 1, 2, 3],

      cameraButtons: [],
      actionButtons: [],
      emotionButtons: [],
      idleButtons: [],
      disabledButtons: [{ label: "조잘조잘" }, { label: "야호 신난다 \\./" }, { label: "슬퍼 ㅠ.ㅠ" }],
    };
  },
  methods: {
    onClickCollapse() {
      this.openPanelFlags = [];
    },
    onClickExpand() {
      this.openPanelFlags = [0, 1, 2, 3];
    },
    activeShortcut(actionId) {
      this.$el.querySelectorAll(".active-shortcut").forEach((el) => el.classList.remove("active-shortcut"));
      this.$el.querySelector(`#${actionId}`).classList.add("active-shortcut");
    },
  },
  watch: {
    actions: {
      handler(actions) {
        this.cameraButtons = [];
        this.actionButtons = [];
        this.emotionButtons = [];

        actions.forEach((action) => {
          const { actionId } = action;
          if (["camera--restore"].includes(actionId)) {
            this.cameraButtons.push(action);
          } else if (
            [
              "animation--hi",
              "animation--thankyou",
              "animation--agree",
              "animation--deahat",
              "animation--die",
            ].includes(actionId)
          ) {
            this.actionButtons.push(action);
          } else if (["animation--angry", "animation--embarrassment", "animation--happy"].includes(actionId)) {
            this.emotionButtons.push(action);
          } else {
            this.idleButtons.push(action);
          }
        });
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.side-panel__body {
  width: 300px;
}

>>> .v-expansion-panel-header {
  min-height: 20px;
  padding-left: 14px;
  padding-top: 12px;
  padding-bottom: 12px;
}
>>> .v-expansion-panel-content__wrap {
  padding: 0;
  padding-left: 16px;
  padding-bottom: 4px;
}

.keypad {
  background-color: rgba(0, 0, 0, 0.3);
  min-height: 100px;
  padding: 6px;
  border-radius: 6px;
}

.my-span {
  font-size: 14px;
  color: white;
  -webkit-animation: glow 1s ease-in-out infinite alternate;
  -moz-animation: glow 1s ease-in-out infinite alternate;
  animation: glow 1s ease-in-out infinite alternate;
}

.active-shortcut span {
  color: red;
}
</style>
